<template>
  <ion-page>
    <!-- Header -->
    <ion-header class="header-container">
      <ion-toolbar class="header-toolbar">
        <ion-buttons slot="start">
          <ion-back-button
            default-href="/admin"
            color="light"
            text=""
          ></ion-back-button>
        </ion-buttons>
        <ion-title class="page-title">
          Order # {{ orderId.replace(/-/gi, "").toUpperCase().substring(0, 6) }}
        </ion-title>
      </ion-toolbar>
    </ion-header>

    <!--content start -->
    <ion-content>
      <ion-row class="heading-row-list">
        <h1 class="heading-category">{{ customerName }}</h1>
      </ion-row>
      <div
        class="orderlist-div"
        v-for="cartOrder in cartOrders"
        :key="cartOrder.id"
      >
        <ion-row class="row-orderlist">
          <ion-col size="1">
            <span class="product-cart-quantity">
              {{ cartOrder.quantity }} x
            </span>
          </ion-col>
          <ion-col>
            <span class="product-cart-name">
              {{ cartOrder.product.productName }}
            </span>
            <div
              v-for="(variation, key) in cartOrder.variations || []"
              :key="key"
            >
              <span class="product-cart-addon" v-if="variation !== null">
                <span
                  v-if="variation.type || variation.category"
                  class="variation-category"
                >
                  {{ toTitleCase(variation.type || variation.category) }}:
                </span>
                <span class="variation-value">{{ variation.name }}</span>
              </span>
            </div>
            <div v-if="cartOrder.instructions !== ''">
              <span class="product-cart-name">
                Special Instructions: <br />
              </span>
              <span class="product-cart-addon">
                {{ cartOrder.instructions }}
              </span>
            </div>
          </ion-col>
          <ion-col>
            <span class="product-cart-price">
              $ {{ parseFloat(cartOrder.pricePerOrder || 0).toFixed(2) }}
            </span>
          </ion-col>
        </ion-row>
      </div>

      <ion-row class="payment-row">
        <ion-col size="6" class="payment-col">
          <span class="payment-label">Order Date & Time</span>
        </ion-col>
        <ion-col size="6" class="payment-col">
          <span class="payment-label2">{{
            formatOrderDate(dateTimeOrdered)
          }}</span>
        </ion-col>
      </ion-row>

      <ion-row class="payment-row">
        <ion-col size="6" class="payment-col">
          <span class="payment-label">Order Status</span>
        </ion-col>
        <ion-col size="6" class="payment-col">
          <span class="payment-label2">{{ orderStatus.toUpperCase() }}</span>
        </ion-col>
      </ion-row>

      <ion-row class="payment-row">
        <ion-col size="6" class="payment-col">
          <span class="payment-label">Pickup Date & Time</span>
        </ion-col>
        <ion-col size="6" class="payment-col">
          <span class="payment-label2">{{ dateTimeForPickup }}</span>
        </ion-col>
      </ion-row>

      <ion-row class="payment-row">
        <ion-col size="6" class="payment-col">
          <ion-icon src="assets/icon/card.svg" class="banner-icon"></ion-icon>
          <span class="payment-label">Payment Method</span>
        </ion-col>
        <ion-col size="6" class="payment-col">
          <img src="assets/icon/stripe.jpg" class="banner-icon2" />
        </ion-col>
      </ion-row>
    </ion-content>

    <!-- Pricing footer -->
    <ion-footer v-if="isLoaded" class="pricing-footer">
      <ion-row class="row-sub">
        <ion-col>
          <span class="product-sublabel">
            SubTotal: {{ totalCartQty }} item/s
          </span>
        </ion-col>
        <ion-col>
          <span class="product-subtotal">
            $ {{ Number(subTotalCartPrice || 0).toFixed(2) }}
          </span>
        </ion-col>
      </ion-row>
      <ion-row v-if="discountPrice > 0" class="row-sub">
        <ion-col><span class="product-sublabel">Discount</span> </ion-col>
        <ion-col>
          <span class="product-subtotal">
            - $ {{ Number(discountPrice || 0).toFixed(2) }}
          </span>
        </ion-col>
      </ion-row>
      <ion-row class="row-sub">
        <ion-col><span class="product-sublabel">Service Fee</span> </ion-col>
        <ion-col>
          <span class="product-subtotal">
            $ {{ Number(serviceFee || 0).toFixed(2) }}
          </span>
        </ion-col>
      </ion-row>
      <ion-row class="row-total">
        <ion-col><span class="product-total-label">Total</span> </ion-col>
        <ion-col>
          <span class="product-cart-price2">
            $ {{ Number(totalCartPrice || 0).toFixed(2) }}
          </span>
        </ion-col>
      </ion-row>
      <div v-if="actionBtn == 'confirm'">
        <ion-button
          expand="block"
          color="primary"
          class="carttext-btn"
          @click="confirmOrder(this.orderId)"
        >
          Confirm Order
        </ion-button>
      </div>
      <div v-if="actionBtn == 'finish'">
        <ion-button
          expand="block"
          color="primary"
          class="carttext-btn"
          @click="confirmAlert(this.orderId)"
        >
          Finish Order
        </ion-button>
      </div>
    </ion-footer>
  </ion-page>
</template>
<script>
import { defineComponent } from "vue";
import axios from "axios";
import { printOrderTicket } from "@/services/orderPrintService";
import { formatOrderDate } from "@/utils/dateFormat";
import {
  IonRow,
  IonCol,
  IonModal,
  IonButton,
  IonItem,
  IonSelect,
  IonSelectOption,
  IonDatetime,
  IonDatetimeButton,
  IonPage,
  IonContent,
  IonHeader,
  IonFooter,
  IonToolbar,
  IonButtons,
  IonBackButton,
  IonTitle,
  IonList,
  IonIcon,
  alertController,
  toastController,
} from "@ionic/vue";

const BASE_URI =
  process.env.VUE_APP_BASE_URI !== undefined
    ? process.env.VUE_APP_BASE_URI
    : "https://api.onecoffeeapp.com.au";

export default defineComponent({
  name: "OrderCardDetails",
  components: {
    IonRow,
    IonCol,
    IonModal,
    IonButton,
    IonItem,
    IonSelect,
    IonSelectOption,
    IonDatetime,
    IonDatetimeButton,
    IonPage,
    IonContent,
    IonHeader,
    IonFooter,
    IonToolbar,
    IonButtons,
    IonBackButton,
    IonTitle,
    IonList,
    IonIcon,
  },
  data() {
    return {
      isLoaded: false,
      cartOrders: [],
      totalCartQty: 0,
      subTotalCartPrice: 0,
      serviceFee: 0,
      totalCartPrice: 0,
      cafeId: "",
      cafeName: "",
      cafeAddress: "",
      orders: [],
      orderId: "",
      actionBtn: "",
      dateTimeOrdered: "",
      orderStatus: "",
      dateTimeForPickup: "",
      customerName: "",
      discountPrice: 0,
    };
  },
  methods: {
    formatOrderDate,
    /**
     * Convert a string to title case
     * Handles "ice level" -> "Ice Level", "ice_level" -> "Ice Level"
     */
    toTitleCase(str) {
      if (!str) return "";
      return str
        .replace(/_/g, " ")
        .split(" ")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(" ");
    },
    async presentToast(message, type = "success") {
      const cssClass =
        type === "success" ? "custom-toast" : `custom-toast toast-${type}`;

      const toast = await toastController.create({
        message: message,
        duration: 2000,
        position: "top",
        cssClass: cssClass,
      });

      await toast.present();
    },
    async showToast(message, color = "medium") {
      const toast = await toastController.create({
        message: message,
        duration: 3000,
        position: "bottom",
        color: color,
      });
      await toast.present();
    },
    async confirmAlert(orderId) {
      const alert = await alertController.create({
        subHeader:
          "Are you sure you want to finish this order? It will be moved to order history right after.",
        buttons: [
          {
            text: "No",
            role: "cancel",
            handler: () => {},
          },
          {
            text: "Yes",
            role: "confirm",
            handler: () => {
              this.finishOrder(orderId);
            },
          },
        ],
      });

      await alert.present();
      await alert.onDidDismiss();
    },
    async getCartOrders(cartOrderIds) {
      let axiosConfig = {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json;charset=UTF-8",
        },
      };

      let url =
        BASE_URI + "/cart/admin/get-cart-orders/?cartOrderIds=" + cartOrderIds;

      let result = await axios
        .get(url, axiosConfig)
        .then((res) => res.data)
        .catch((err) => {
          this.presentToast("This order is not available.", "danger");
          throw err.response.status;
        });

      this.cartOrders = result && result.data.length ? await result.data : [];

      for (let i = 0; i < this.cartOrders.length; i++) {
        this.totalCartQty += this.cartOrders[i].quantity;
        this.subTotalCartPrice +=
          parseFloat(this.cartOrders[i].pricePerOrder) || 0;
      }

      this.cafeId = this.cartOrders[0].cafe.cafeId;
      this.cafeName = this.cartOrders[0].cafe.shopName;
      this.cafeAddress = this.cartOrders[0].cafe.address;
    },
    async getOrdersById(orderId) {
      let axiosConfig = {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json;charset=UTF-8",
        },
      };

      let url = BASE_URI + "/orders/admin/get-orders-by-id/?orderId=" + orderId;

      let result = await axios
        .get(url, axiosConfig)
        .then((res) => res.data)
        .catch((err) => {
          this.presentToast("This order is not available anymore.", "danger");
          throw err.response.status;
        });

      this.orders = result && result.data.length ? await result.data : [];
      this.orderStatus = result.data[0].orderStatus;
      this.customerName = result.data[0].customerInfo.fullName;
      this.discountPrice = parseFloat(result.data[0].discount) || 0;
      this.serviceFee = parseFloat(result.data[0].serviceFee) || 0;
      this.totalCartPrice = parseFloat(result.data[0].total) || 0;

      // Use formatted date for display
      this.dateTimeOrdered = result.data[0].dateTimeOrdered;

      // Use raw date for pickup time calculation (+15 minutes)
      const rawDate = result.data[0]?.dateTimeOrderedRaw;
      if (rawDate && typeof rawDate === "string" && rawDate.trim()) {
        const orderDate = new Date(rawDate);
        if (isFinite(orderDate.getTime())) {
          const pickupDate = new Date(orderDate.getTime() + 15 * 60000); // Add 15 minutes

          // Format pickup date to match order date format (DD/MM/YYYY HH:MM AM/PM)
          const formatOptions = {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          };

          const formatted = pickupDate.toLocaleString("en-GB", formatOptions);
          // Convert from "DD/MM/YYYY, HH:MM am" to "DD/MM/YYYY HH:MM AM"
          this.dateTimeForPickup = formatted.replace(",", "").toUpperCase();
        } else {
          this.dateTimeForPickup = this.dateTimeOrdered;
        }
      } else {
        this.dateTimeForPickup = this.dateTimeOrdered;
      }
    },
    async confirmOrder(orderId) {
      // Print the order before confirming
      try {
        if (this.cartOrders && this.cartOrders.length > 0) {
          // Build order object for printing
          const order = {
            uuid: orderId,
            dateTimeOrdered: this.dateTimeOrdered,
            customerInfo: {
              fullName: this.customerName ?? "Unknown Customer",
            },
          };

          // Print the order ticket
          const printResult = await printOrderTicket(order, this.cartOrders);

          if (printResult.success) {
            await this.showToast("Order printed successfully", "success");
          } else if (!printResult.skipped) {
            // Show warning but continue with confirmation
            await this.showToast(
              `Warning: Print failed - ${printResult.message}`,
              "warning"
            );
          }
        }
      } catch (error) {
        console.error("Error printing order:", error);
        await this.showToast(
          "Warning: Print failed, but order will be confirmed",
          "warning"
        );
      }

      // Continue with order confirmation
      let updateOrderData = {
        orderId: orderId,
        status: "ready",
      };

      let axiosConfig = {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json;charset=UTF-8",
        },
      };

      let orderResult = await axios.put(
        BASE_URI + "/orders/update-order",
        updateOrderData,
        axiosConfig
      );

      if (orderResult.status === 200) {
        await this.presentToast("Order has been confirmed.", "success");
        window.location.href = "/admin";
      } else {
        await this.presentToast(orderResult.data.error, "danger");
      }
    },
    async finishOrder(orderId) {
      let updateOrderData = {
        orderId: orderId,
        status: "collected",
      };

      let axiosConfig = {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json;charset=UTF-8",
        },
      };

      let orderResult = await axios.put(
        BASE_URI + "/orders/update-order",
        updateOrderData,
        axiosConfig
      );

      if (orderResult.status === 200) {
        await this.presentToast("Order has been finished.", "success");
        window.location.href = "/admin";
      } else {
        await this.presentToast(orderResult.data.error, "danger");
      }
    },
  },
  async created() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const cartOrderIds = urlParams.get("cartOrderIds") || "";
    this.orderId = urlParams.get("orderId") || "";
    this.actionBtn = urlParams.get("action") || "";

    if (cartOrderIds && this.orderId) {
      await this.getCartOrders(cartOrderIds);
      await this.getOrdersById(this.orderId);
      this.isLoaded = true;
    } else {
      this.presentToast("No order has been selected.", "danger");
    }
  },
});
</script>
<style scoped>
.header-container {
  --background: #f87e63;
}

.header-toolbar {
  --background: #f87e63;
  --border-width: 0;
  --padding-top: 8px;
  --padding-bottom: 8px;
  --padding-start: 16px;
  --padding-end: 16px;
  --min-height: 64px;
}

.page-title {
  --color: #ffffff;
  font-family: "Gilroy", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
}

.pricing-footer {
  --background: #ffffff;
  background: #ffffff;
}

.center {
  margin: auto;
}

.heading-row-list {
  background-color: #f9f9f9;
  padding-left: 5%;
  border-bottom: 1px solid #f3f3f3;
}
.heading-category {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: right;
  color: #1b1b1b;
  margin-top: 8%;
  margin-bottom: 15px;
}
.row-sub {
  padding-top: 0%;
  padding-left: 5%;
  padding-right: 0%;
}
.row-orderlist {
  padding-top: 0%;
  padding-left: 3%;
  padding-right: 0%;
}
.row-total {
  padding-top: 3%;
  padding-left: 2%;
  padding-right: 5%;
  padding-bottom: 20px;
  margin-top: 3%;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.06);
}
.orderlist-div {
  padding-top: 10px;
  padding-bottom: 10px;
}
.product-cart-quantity {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 140%;
  color: #1b1b1b;
}
.product-cart-name {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 140%;
  color: #1b1b1b;
  display: block;
  padding: 0%;
}
.product-cart-addon {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #828282;
  display: block;
  padding: 0 10px;
}
.product-total-label {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 140%;
  color: #828282;
  display: block;
  padding: 2%;
}
.product-cart-edit {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 140%;
  color: #f87e63;
  display: block;
  padding: 2%;
}
.product-cart-price {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  color: #1b1b1b;
  position: absolute;
  right: 16px;
}
.product-cart-price2 {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 140%;
  color: #1b1b1b;
  position: absolute;
  right: -5px;
}
.product-subtotal {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  color: #1b1b1b;
  position: absolute;
  right: 16px;
}
.product-sublabel {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  color: #1b1b1b;
  display: block;
}
ion-button {
  --background: #ffffff;
  --background-hover: #dce8ff;
  --background-activated: #dce8ff;
  --background-focused: #dce8ff;
  --color: #1b1b1b;
  --border-radius: 4px;
  --border-color: #f3f3f3;
  --border-style: solid;
  --border-width: 1px;
  --ripple-color: #dce8ff;
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  margin-left: 15px;
  margin-right: 15px;
  height: 52px;
  text-transform: none;
  --box-shadow: none;
}
ion-button:active {
  --color: #f87e63;
}
.carttext-btn {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
}
ion-select {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 120%;
  --placeholder-color: #ffc34d;
  --placeholder-opacity: 1;
}
ion-select::part(icon) {
  color: #ffffff;
  opacity: 0;
}
ion-select-option {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 120%;
  color: #1b1b1b;
}
.select-fr {
  float: right;
}
.checkout-row {
  border-bottom: 1px solid #f3f3f3;
  padding-top: 5%;
  padding-bottom: 5%;
}
.payment-row {
  border-bottom: 1px solid #f3f3f3;
}
.payment-col {
  padding-top: 5%;
  padding-left: 5%;
  padding-bottom: 5%;
}
.pickup-txt {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 120%;
  color: #1b1b1b;
}
.payment-option {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 140%;
  color: #1b1b1b;
  display: block;
}
.banner-icon {
  vertical-align: middle;
  padding-right: 5px;
  width: 14px;
}
.trash-icon {
  width: 16px;
}
.payment-label {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 135%;
  letter-spacing: 0.02em;
  color: #1b1b1b;
  margin-left: 5px;
}
.payment-label2 {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 135%;
  letter-spacing: 0.02em;
  color: #1b1b1b;
  margin-right: 15px;
  float: right;
}
.payment-option {
  display: block;
}
.banner-icon2 {
  vertical-align: middle;
  padding-right: 5px;
  width: 80px;
  float: right;
  height: 35px;
}
.custom-toast {
  --background: #ffffff;
  --color: #1b1b1b;
  --border-radius: 10px;
  --box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  font-family: "Gilroy", sans-serif;
  font-weight: 500;
  font-size: 14px;
}

.custom-toast.toast-danger {
  --background: #ffe0e3;
  --color: #1b1b1b;
}

.custom-toast.toast-warning {
  --background: #fff0d9;
  --color: #1b1b1b;
}
.variation-category {
  font-weight: 400;
  color: #828282;
}
.variation-value {
  font-weight: 600;
  color: #1b1b1b;
}
</style>
